import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { verifyAdmin } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const ok = await verifyAdmin();
      setIsAuth(ok);
      setLoading(false);
    };
    checkAuth();
  }, []);

  // loading screen (important to prevent flashing UI)
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-gray-600">
        Checking authentication...
      </div>
    );
  }

  if (!isAuth) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute;
